import { ModalOverlay, ModalContent, Close } from 'components/Modal/Modal';
import styled from 'styled-components';
import { COLORS } from 'styles/variables';

export const CustomOverlay = styled(ModalOverlay)`
  background: #a9a9a9 0% 0% no-repeat padding-box;
  filter: none;
`;

export const CustomContentWrapper = styled(ModalContent)`
  display: flex;
  border-radius: 5.5rem;
  flex-direction: column;
  box-shadow: 10px 15px 8px #8e8e8e;
  transform: translate(-50%, -40%);
  background-color: #fcfaf7;
  padding-bottom: 0;
  border-radius: 5.5rem;
  max-width: 50rem;
  min-height: 60rem;

  .catalog-helper-image {
    display: block;
    position: absolute;
    width: 100%;
    max-width: 40rem;
    height: auto;
    left: 50%;
    transform: translateX(-50%);
    top: -30%;
  }

  .contact {
    &-wrapper {
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: start;
      gap: 1rem;
      background-color: white;
      padding: 2rem 2.5rem 0;
      border-radius: 0 0 5.5rem 5.5rem;

      .highlight {
        color: ${COLORS.RED};
      }

      .promo-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2rem;
        justify-content: center;
        width: 100%;
      }

      .promo {
        display: flex;
        align-items: center;
        gap: 2rem;

        .price {
          &-old {
            position: relative;
            color: ${COLORS.RED};
            font-size: 2.6rem;
            font-weight: normal;

            ::after {
              content: '';
              position: absolute;
              display: block;
              width: 103%;
              height: 2px;
              background-color: ${COLORS.RED};
              bottom: 5px;
              transform: rotate(342deg);
              transform-origin: bottom left;
            }
          }

          &-new {
            font-size: 5rem;
            color: ${COLORS.BLUE_1};
          }
        }
      }
    }

    &-btn {
      display: block;
      max-width: max-content;
      font-size: 2.2rem;
    }
  }

  ul {
    list-style-type: none;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    font-size: 1.5rem;
  }

  .help-text {
    margin-bottom: 1.2rem;
    font-size: 2rem;
    text-align: center;
  }

  .title {
    padding: 18rem 8rem 1rem;
    text-align: center;
  }

  .not-show-again {
    margin-bottom: 3rem;
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .underline {
    text-decoration: underline;
  }

  .italic {
    font-style: italic;
  }
`;

export const CustomCloseButton = styled(Close)`
  top: -10rem;
  right: -5rem;
`;
